import { render } from "./FirePermitForm.vue?vue&type=template&id=6aff4601"
import script from "./FirePermitForm.vue?vue&type=script&lang=ts"
export * from "./FirePermitForm.vue?vue&type=script&lang=ts"
script.render = render

export default script